<template>
  <div class="main-content">
    <!-- VIP规则列表页 -->
    <div v-if="showFlag">
      <el-form :inline="true" :model="searchForm" class="form-content">
        <el-row :gutter="20" class="slt" :style="{ justifyContent: 'flex-start' }">
          <el-form-item :label="$t('vip.vipLevel')">
            <el-input v-model="searchForm.viplevel" :placeholder="$t('vip.vipLevel')" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="search()">{{ $t('common.search') }}</el-button>
          </el-form-item>
        </el-row>

        <el-row class="ad" :style="{ justifyContent: 'flex-start' }">
          <el-form-item>
            <el-button v-if="isAuth('viprule','新增')" type="success" @click="addOrUpdateHandler()">{{ $t('common.add') }}</el-button>
            <el-button v-if="isAuth('viprule','删除')" type="danger" @click="deleteHandler()" :disabled="dataListSelections.length <= 0">{{ $t('common.delete') }}</el-button>
          </el-form-item>
        </el-row>
      </el-form>

      <div class="table-content">
        <el-table :data="dataList" border stripe style="width: 100%" v-loading="dataListLoading" @selection-change="selectionChangeHandler">
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column type="index" :label="$t('table.index')" width="50" align="center"></el-table-column>
          <el-table-column prop="viplevel" :label="$t('vip.vipLevel')" align="center"></el-table-column>
          <el-table-column prop="discount" :label="$t('vip.discount')" align="center">
            <template slot-scope="scope">{{ scope.row.discount }}{{ $t('vip.discountUnit') }}</template>
          </el-table-column>
          <el-table-column prop="amount" :label="$t('vip.price')" align="center"></el-table-column>

          <el-table-column prop="duration" :label="$t('vip.validityPeriod')" align="center"></el-table-column>
          <el-table-column prop="createdtime" :label="$t('table.createTime')" align="center">
            <template slot-scope="scope">{{ $options.filters.dateFormat(scope.row.createdtime) }}</template>
          </el-table-column>
          <el-table-column prop="updatedtime" :label="$t('table.updateTime')" align="center">
            <template slot-scope="scope">{{ $options.filters.dateFormat(scope.row.updatedtime) }}</template>
          </el-table-column>
          <el-table-column :label="$t('table.actions')" width="200" align="center">
            <template slot-scope="scope">
              <el-button v-if="isAuth('viprule','查看')" type="success" size="mini" @click="addOrUpdateHandler(scope.row.id,'info')">{{ $t('table.view') }}</el-button>
              <el-button v-if="isAuth('viprule','修改')" type="primary" size="mini" @click="addOrUpdateHandler(scope.row.id)">{{ $t('table.modify') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="totalPage"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination-content"
        ></el-pagination>
      </div>
    </div>
    <!-- 添加/修改页面 -->
    <add-or-update v-if="addOrUpdateFlag" :parent="this" ref="addOrUpdate"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from './add-or-update'
export default {
  components: { AddOrUpdate },
  filters: {
    dateFormat(date) {
      if (!date) return '';
      return new Date(date).toLocaleString();
    }
  },
  data() {
    return {
      searchForm: {
        viplevel: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      showFlag: true,
      addOrUpdateFlag: false
    }
  },
  created() {
    this.getDataList();
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      this.$http({
        url: 'viprule/list',
        method: 'get',
        params: {
          page: this.pageIndex,
          limit: this.pageSize,
          viplevel: this.searchForm.viplevel
        }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.page.list;
          this.totalPage = data.page.totalCount;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandler(val) {
      this.dataListSelections = val;
    },
    // 添加/修改
    addOrUpdateHandler(id, type) {
      this.showFlag = false;
      this.addOrUpdateFlag = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, type);
      });
    },
    // 删除
    deleteHandler(id) {
      const ids = id ? [id] : this.dataListSelections.map(item => item.id);
      this.$confirm(this.$t('common.confirm') + '进行[' + (id ? this.$t('common.delete') : '批量' + this.$t('common.delete')) + ']操作?', this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(() => {
        this.$http({
          url: 'viprule/delete',
          method: 'post',
          data: ids
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: this.$t('common.operation') + '成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList();
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
    // 搜索
    search() {
      this.pageIndex = 1;
      this.getDataList();
    }
  }
}
</script>